import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";
import ContactForm from "../components/ContactForm";
import { ArrowRight, Award, Users, Factory } from "lucide-react";

export default function About() {
  return (
    <>
      <Header />

      <section className="relative h-[40vh] min-h-[300px] bg-[#0a0a0a] flex items-center">
        <div className="absolute inset-0 opacity-40" style={{
          backgroundImage: "url('https://images.pexels.com/photos/22717514/pexels-photo-22717514.jpeg?w=1600')",
          backgroundSize: "cover", backgroundPosition: "center"
        }} />
        <div className="relative max-w-7xl mx-auto px-6">
          <span className="inline-block text-[11px] font-bold tracking-[0.25em] text-[#f5a623] mb-3">ABOUT EMC</span>
          <h1 className="display-font text-5xl md:text-6xl font-bold text-white">Built by Hands. Backed by History.</h1>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-6 -mt-24 relative z-10">
          {[
            { I: Award, t: "40+ Years", d: "Engineering & fabrication experience" },
            { I: Users, t: "Family-Owned", d: "Three generations of craftsmen" },
            { I: Factory, t: "Miami HQ", d: "32,000 sq. ft. production facility" },
          ].map(({ I, t, d }) => (
            <Reveal key={t}>
              <div className="bg-white border border-[#e6e6e6] p-7 text-center hover:border-[#f5a623] transition-colors">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-[#0a0a0a] text-[#f5a623] mb-4">
                  <I className="w-6 h-6" />
                </div>
                <h3 className="display-font text-xl font-bold">{t}</h3>
                <p className="text-[#555] mt-1">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="max-w-4xl mx-auto px-6 mt-20">
          <Reveal>
            <h2 className="display-font text-3xl md:text-4xl font-bold mb-5">Our story is straightforward.</h2>
            <div className="space-y-5 text-[#444] text-lg leading-relaxed">
              <p>EMC Industrial began in a single bay in Miami in 1985 — one welder, one bender, and a phone that wouldn’t stop ringing. Local farmers needed repair parts; contractors needed tanks; haulers needed trailers. We said yes.</p>
              <p>Forty years later, the bay grew into a 32,000 sq. ft. fabrication shop, and the customer list grew with it. We became the authorized TATU Marchesan dealer for the Southeast, expanded into custom enclosures and fuel storage, and added CNC plasma to the floor.</p>
              <p>What hasn’t changed: family ownership, an obsessive commitment to clean welds, and the standing rule that every customer leaves the shop with a phone number they can actually call.</p>
            </div>
            <Link to="/" className="inline-flex items-center gap-2 btn-primary px-6 py-3 mt-8 font-semibold">
              See Our Capabilities <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>
      </section>

      <ContactForm />
      <Footer />
    </>
  );
}
